import script from "./AddedDatasetsUI.vue?vue&type=script&setup=true&lang=js"
export * from "./AddedDatasetsUI.vue?vue&type=script&setup=true&lang=js"

import "./AddedDatasetsUI.vue?vue&type=style&index=0&id=fd5c71a4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd5c71a4"]])

export default __exports__